import { BellRing, BellOff, Share, Loader2, ShieldX, PlugZap, Smartphone } from 'lucide-react'
import { usePush } from './usePush'
import './push.css'

/** Full push control for the Settings view — status + enable/disable. */
export function PushSettings() {
  const { status, busy, error, enable, disable } = usePush()

  return (
    <div className="pushset card">
      <div className="pushset__head">
        <div className="pushset__icon">{status === 'subscribed' ? <BellRing size={20} /> : <BellOff size={20} />}</div>
        <div>
          <p className="pushset__title">Warning alerts</p>
          <p className="pushset__sub">Web push for NWS warnings at your saved location.</p>
        </div>
        {status === 'subscribed' && (
          <button className="btn btn--ghost btn--sm" onClick={disable} disabled={busy}>
            {busy ? <Loader2 size={15} className="spin" /> : null} Turn off
          </button>
        )}
        {status === 'available' && (
          <button className="btn btn--primary btn--sm" onClick={enable} disabled={busy}>
            {busy ? <Loader2 size={15} className="spin" /> : <BellRing size={15} />}
            {busy ? '…' : 'Enable'}
          </button>
        )}
      </div>

      {error && <p className="pushset__note pushset__note--err">{error}</p>}

      {status === 'subscribed' && <p className="pushset__note pushset__note--ok">On — you’ll be notified of new warnings.</p>}

      {status === 'needs-install' && (
        <p className="pushset__note">
          <Smartphone size={15} /> Add Triple-A to your Home Screen first: tap <Share size={14} /> Share →{' '}
          <strong>Add to Home Screen</strong>. iOS only delivers push to installed apps.
        </p>
      )}
      {status === 'denied' && (
        <p className="pushset__note">
          <ShieldX size={15} /> Notifications are blocked. Re-enable them for this app in your browser/site settings, then
          reload.
        </p>
      )}
      {status === 'unsupported' && (
        <p className="pushset__note">
          <ShieldX size={15} /> This browser doesn’t support web push.
        </p>
      )}
      {status === 'unconfigured' && (
        <p className="pushset__note">
          <PlugZap size={15} /> Push isn’t wired yet — set <code>VITE_VAPID_PUBLIC_KEY</code> (see the README) to turn this
          on.
        </p>
      )}
    </div>
  )
}
